const TickIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18"><path fill="currentColor" d="M14.25 6.4 7.83 13 3.75 8.8l1.43-1.4 2.65 2.73L12.82 5l1.43 1.4Z"></path></svg>)
}
export default TickIcon